import React from 'react'

import { IFocusPathOptions, IFocusTarget } from './form-focus-target'

/**
 * The imperative handle a FormFocusTargetProvider publishes up to the save host. On a
 * save validation failure the host calls focusFirstError() and the provider walks its
 * registry, jumps the wizard to the first errored path in doc order, and pulses it.
 */
export interface IFormFocusHandle {
  focusFirstError(scope?: { sectionId?: string }): Promise<string | undefined>
  focusPath(path: string, options?: IFocusPathOptions): Promise<boolean>
  getOrderedPaths(): string[]
  getTarget(path: string): IFocusTarget | undefined
}

export type FormFocusHandleSetter = (handle: IFormFocusHandle | null) => void

export const FormFocusHandleContext = React.createContext<FormFocusHandleSetter | undefined>(undefined)
